

const ActionEnvoieReducer = (state, action) => {
    switch (action.type) {
        case "GET_ACTIONS_ENVOIS_START":
            return {
                ...state,
                actionsEnvois: [],
                isFetching: true,
                error: false,
            };
        case "GET_ACTIONS_ENVOIS_SUCCESS":
            return {
                ...state,
                actionsEnvois: action.payload.actionsEnvois,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_ACTIONS_ENVOIS_FAILURE":
            return {
                ...state,
                actionsEnvois: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_ACTION_ENVOIE_START":
            return {
                ...state,
                actionEnvoie: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_ACTION_ENVOIE_SUCCESS":
            return {
                ...state,
                actionEnvoie: action.payload.actionEnvoie,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_ACTION_ENVOIE_FAILURE":
            return {
                ...state,
                actionEnvoie: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_ACTION_ENVOIE_START":
            return {
                ...state,
                actionEnvoieUpdate: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_ACTION_ENVOIE_SUCCESS":
            return {
                ...state,
                actionEnvoieUpdate: action.payload.actionEnvoie,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_ACTION_ENVOIE_FAILURE":
            return {
                ...state,
                actionEnvoieUpdate: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
       default:
            return { ...state };
    }
}

export default ActionEnvoieReducer;